import { render, staticRenderFns } from "./List-OrderDetail.vue?vue&type=template&id=5cae67ad&scoped=true"
import script from "./List-OrderDetail.vue?vue&type=script&lang=js"
export * from "./List-OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./List-OrderDetail.vue?vue&type=style&index=0&id=5cae67ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae67ad",
  null
  
)

export default component.exports